import React from "react";
import SuppliersForm from "./SuppliersForm";
import {none} from "ts-option";
import {makeStyles, Paper} from "@material-ui/core";
import {defaultStyles} from "../../styles/defaultStyles";

const useStyles = makeStyles(defaultStyles);

const SuppliersCreate = () => {
    const classes = useStyles();
    return (
        <Paper className={classes.defaultPaper}>
            <SuppliersForm supplier={none}/>
        </Paper>
    )
};

export default SuppliersCreate;